module.exports = __webpack_public_path__ + "img/solution9.0c8d9f1f.png";